import React, {useContext} from 'react';
import PropType from 'prop-types';
import './WelcomeTooltip.css';
import DragToRotateTooltip from '../DragToRotateTooltip/DragToRotateTooltip';
import { isMobileDevice } from 'web-store-modules/packages/obsess-device-detector';
import { Button } from 'web-store-modules/packages/web-store-ui-library';
import { withTranslation } from 'react-i18next';
import I18NextContext from '../../../ui/i18next-context/I18NextContext';

const browseImg = 'https://cdn.obsess-vr.com/ferragamo/welcome/welcome-mousee.gif';
const productImg = 'https://cdn.obsess-vr.com/ferragamo/welcome/welcome-product';
const beautyImg = "https://cdn.obsess-vr.com/ferragamo/welcome/hotspot.svg";
const exploreImg = 'https://cdn.obsess-vr.com/ferragamo/welcome/welcome-exploree.svg';
const isMobile = isMobileDevice();
const desktopTooltip = !isMobile ? {top:'0%'} : {};
const buttonWidth = isMobile ? '240px' : '210px';


const WelcomeTooltip = (props) => {
    const { welcomeMessageStyle, children, showBroseTooltip, showProductTooltip, showBeautyTooltip, isVisible,
        storeId, showMobileTooltip, isMobile, onWelcomeHide, t } = props;
    const tooltipClass = !isVisible ? 'tooltip-fadeout' : ''
    const i18nextContext = useContext(I18NextContext);

    const onModalHidden = () => {
        onWelcomeHide();
    }

    return (
        <div id="tooltip-container" className={tooltipClass} style={desktopTooltip}>
            <div id="tooltip-component-container" className="flex-center">
                <div className="tooltip-row">
                    <div className="tooltip-col fadeInTooltip" style={{marginBottom: i18nextContext.currentLanguage === 'jpn_ja' && isMobile && '20px' }}>
                        <h3>{t('cta1CoverLegend')}</h3>
                        <span className="tooltip-message">
                            {t('mouseIconCover')}
                        </span>
                        <DragToRotateTooltip imgStyle={{ width: '7em', height: '7em', marginBottom: i18nextContext.currentLanguage === 'jpn_ja' && isMobile && '20px'  }} isTemplate image={browseImg} classes={'tooltip-first-img'} />
                    </div>
                    <div className={'tooltip-col ' + (showProductTooltip ? 'fadeInTooltip' : '')}>
                        {showProductTooltip && <><h3>{t('cta2CoverLegend')}</h3>
                            <span className="tooltip-message">
                            {t('productIconCover')}
                            </span>
                            <DragToRotateTooltip imgStyle={{ width: '5em', height: '5em' }} isTemplate image={productImg} /> </>}
                    </div>
                    <div className={'tooltip-col ' + (showBeautyTooltip ? 'fadeInTooltip' : '')}>
                        {showBeautyTooltip && <><h3>{t('cta3CoverLegend')}</h3>
                            <span className="tooltip-message">
                            {t('exploreIconCover')}
                            </span>
                            <DragToRotateTooltip  isTemplate image={exploreImg} classes={'star exploreIcon'} /></>}
                    </div>
                </div>
                <Button
                    hoverStyleChange={false}
                    onClick={onModalHidden}
                    primaryColor='#EFE0A6'
                    secondaryColor='#EFE0A6'
                    className="product-button flex-center obsessvr-regularFont full-width pointer exploreNowBtn"
                    style={{ padding: '0', borderRadius: '4px', width: buttonWidth,pointerEvents: 'all' }}
                    primaryBorderColor={"#EFE0A6"}
                    secondaryBorderColor={"#EFE0A6"}
                    insetBorder={true}
                    padded={false}
                >
                    <span className='obsessvr-regularFont ' style={{color:'black',fontSize: '11px',fontFamily: 'MessinaSans-SemiBold'}}>
                        {t('ctaMainCoverLegend')}
                    </span>
                </Button>
                {children}
            </div>
        </div>
    );
};

WelcomeTooltip.propTypes = {
    welcomeMessageStyle: PropType.object,
    showBroseTooltip: PropType.bool,
    showBeautyTooltip: PropType.bool,
    showProductTooltip: PropType.bool,
};

export default withTranslation()(WelcomeTooltip);
